import ApiService from './api.service'

const AuthService = {

  /***
   * Log in using a one-time use password
   * @param {string} params.contact email address of the user
   * @param {string} params.password password provided in SMS/email
   * @returns {*}
   */
  loginOtp (params) {
    return ApiService.post('auth/login-otp', params)
  },
  /***
   * Log in user, returns an error if unable to authenticate
   * @param {string} params.email_address email address of the user/staff member to log in as
   * @param {string} params.password password of the user
   * @returns {*}
   */
  login (params) {
    return ApiService.post('auth/login', params)
  },

}
export default AuthService
